import { useMemo } from 'react';

import useSearchParamsState from '@/src/hooks/useSearchParamsState';

import { StatusFilterEnum, View } from './types';

type SearchParams = {
  [key: string]: string;
};

export type InboxSearchParams = {
  view?: View;
  filter?: StatusFilterEnum;
  isTrash?: boolean;
  searchParams?: SearchParams;
  setParams?: (searchParams: SearchParams) => void;
  clearSearchParams?: (retainedParams: SearchParams) => void;
};

const useInboxSearchParams = (): InboxSearchParams => {
  const [searchParams, setSearchParamsState, clearSearchParams] = useSearchParamsState();

  const currentSearchParams = useMemo(() => {
    const currentParams = {};
    searchParams.forEach((value, key) => {
      currentParams[key] = value;
    });
    return currentParams;
  }, [searchParams]);

  const setParams = (param: SearchParams) => {
    setSearchParamsState({ ...currentSearchParams, ...param });
  };

  return {
    view: searchParams.get('view') as View,
    filter: searchParams.get('filter') as StatusFilterEnum,
    isTrash: searchParams.get('view') === View.Trash,
    searchParams: currentSearchParams,
    setParams,
    clearSearchParams,
  };
};

export default useInboxSearchParams;
